<template>
  <component
    v-if="getComponentByType(contentElement.content_type)"
    :is="getComponentByType(contentElement.content_type)"
    :content-element="contentElement"
    :is-in-detail-view-edit-mode="isInDetailViewEditMode"
    :entry="entry"
    :list-view="listView"
  ></component>
</template>

<script lang="ts">
  import Vue from "vue";
  import listViewTableMixin from "../mixins/listViewTableMixin";
  import ListViewContentElementModelProperty from "./list-view-content-element-model-property.vue";
  import ListViewContentElementCompositeText from "./list-view-content-element-composite-text.vue";
  import ListViewContentElementModelFormula from "./list-view-content-element-formula.vue";
  import ListViewContentElementModelIconSet from "./list-view-content-element-icon-set.vue";
  import ListViewContentElementDefinition from "~/models/listViews/elements/listViewContentElementDefinition";
  import {ListViewContentElementType} from "~/enums/listViews/listViewContentElementType";

  export default Vue.extend({
    components: {
      'content-element-model-property': ListViewContentElementModelProperty,
      'content-element-composite-text': ListViewContentElementCompositeText,
      'content-element-formula': ListViewContentElementModelFormula,
      'content-element-icon-set': ListViewContentElementModelIconSet,
    },
    mixins: [
      listViewTableMixin,
    ],
    data: function () {
      return {};
    },
    methods: {
      getComponentByType(contentType: ListViewContentElementType): string {
        return ListViewContentElementDefinition.getComponent(contentType);
      },
    },
  });
</script>